// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ISO 19115-1 Status codes for dataset status
 * @export
 */
export const StatusCode = {
  Completed: "completed",
  HistoricalArchive: "historicalArchive",
  Obsolete: "obsolete",
  OnGoing: "onGoing",
  Planned: "planned",
  Required: "required",
  UnderDevelopment: "underDevelopment",
} as const;
export type StatusCode = (typeof StatusCode)[keyof typeof StatusCode];

export function instanceOfStatusCode(value: any): boolean {
  for (const key in StatusCode) {
    if (Object.prototype.hasOwnProperty.call(StatusCode, key)) {
      if (StatusCode[key as keyof typeof StatusCode] === value) {
        return true;
      }
    }
  }
  return false;
}

export function StatusCodeFromJSON(json: any): StatusCode {
  return StatusCodeFromJSONTyped(json, false);
}

export function StatusCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusCode {
  return json as StatusCode;
}

export function StatusCodeToJSON(value?: StatusCode | null): any {
  return value as any;
}

export function StatusCodeToJSONTyped(value: any, ignoreDiscriminator: boolean): StatusCode {
  return value as StatusCode;
}
